import config from "@/config.js";
import V from "@/main"; //- don't remove this line
export default {
  //   namespaced: true,
  state: {
    sidebarShow: "responsive",
    sidebarMinimize: false,
    token: localStorage.getItem("token") || "",
    userDetails: {
      permissions: [],
    },
    isHamburger: false,
  },

  mutations: {
    toggleSidebarDesktop(state) {
      state.isHamburger = !state.isHamburger;
      const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
      state.sidebarShow = sidebarOpened ? false : "responsive";
    },
    toggleSidebarMobile(state) {
      state.isHamburger = !state.isHamburger;
      const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
      state.sidebarShow = sidebarClosed ? true : "responsive";
    },
    set(state, [variable, value]) {
      state[variable] = value;
    },
    setToken(state, token) {
      state.token = token;
      localStorage.setItem("token", token);
    },
    setUserDetails: (state, userDetails) => {
      state.userDetails = userDetails;
    },
    clearPermissions: (state) => {
      state.userDetails.permissions = [];
    },
  },
  actions: {
    setToken(context, payload) {
      context.commit("setToken", payload);
    },
    setUserDetails(context, payload) {
      context.commit("setUserDetails", payload);
    },
  },
  getters: {
    getToken: (state) => {
      return state.token;
    },
    getUserDetails: (state) => {
      return state.userDetails;
    },
    getPermissions: (state) => {
      return state.userDetails.permissions;
    },
  },
};
